export const BUSINESS = {
  name: "JK House Cleaning",
  tagline: "Professional House Cleaning You Can Trust",
  abn: "63 130 899 876",
  phoneDisplay: "0427 510 406",
  phoneRaw: "+61427510406",
  email: "info.jkhousecleaning@gmail.com",
  city: "Melbourne",
  state: "Victoria",
  country: "Australia",
  region: "Melbourne, Victoria, Australia",
  hours: [
    { day: "Monday", time: "9:00 AM – 4:30 PM", open: true },
    { day: "Tuesday", time: "9:00 AM – 4:30 PM", open: true },
    { day: "Wednesday", time: "9:00 AM – 4:30 PM", open: true },
    { day: "Thursday", time: "9:00 AM – 4:30 PM", open: true },
    { day: "Friday", time: "9:00 AM – 4:30 PM", open: true },
    { day: "Saturday", time: "Closed", open: false },
    { day: "Sunday", time: "Closed", open: false },
  ],
};

export const telLink = `tel:${BUSINESS.phoneRaw}`;
export const mailLink = `mailto:${BUSINESS.email}`;

export const WHATSAPP_NUMBER = "61427510406";
export const DEFAULT_WA_MESSAGE =
  "Hi JK House Cleaning,\nI would like a cleaning quote.\nMy suburb is: \nService required: \nPreferred date: ";
export const whatsappLink = (msg = DEFAULT_WA_MESSAGE) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const IMAGES = {
  heroLiving:
    "https://images.unsplash.com/photo-1632829882891-5047ccc421bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  livingSage:
    "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  livingBright:
    "https://images.unsplash.com/photo-1649083048770-82e8ffd80431?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  livingOpen:
    "https://images.unsplash.com/photo-1649083048337-4aeb6dda80bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  kitchenGold:
    "https://images.unsplash.com/photo-1565538810643-b5bdb714032a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  kitchenWood:
    "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  kitchenIsland:
    "https://images.unsplash.com/photo-1502005097973-6a7082348e28?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bathroomModern:
    "https://images.unsplash.com/photo-1643949700215-e61cdca053f7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bathroomWhite:
    "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bedroomSunlit:
    "https://images.unsplash.com/photo-1616486029423-aaa4789e8c9a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bedroomMirror:
    "https://images.unsplash.com/photo-1556020685-ae41abfc9365?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  equipment:
    "https://images.unsplash.com/photo-1528740561666-dc2479dc08ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cleaner:
    "https://images.unsplash.com/photo-1758273238795-c284e5ae09b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  melbourneSkyline:
    "https://images.unsplash.com/photo-1545044846-351ba102b6d5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  melbourneStreet:
    "https://images.unsplash.com/photo-1631283394714-05bdbdebd342?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "About", to: "/about" },
  { label: "Service Areas", to: "/service-areas" },
  { label: "Reviews", to: "/reviews" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const TRUST_BADGES = [
  "ABN Registered",
  "Public Liability Insured",
  "Police Checked",
  "Professional Equipment Supplied",
  "Cleaning Products Supplied",
  "Reliable Service",
  "Flexible Scheduling",
  "Friendly Team",
  "Attention To Detail",
  "Free Quotes",
];
